import React from 'react'
import {
  Radio,
  RadioGroup,
  Stack,
} from '@chakra-ui/react'
import { FastField, FieldAttributes } from 'formik'
import _ from 'lodash'

import { InputWrapper } from './input-wrapper'
import { RadioFormInput } from '../form-types'

interface RadioInputProps {
  id: string;
  input: RadioFormInput;
  isDisabled?: boolean;
}

export const RadioInputComponent: React.FC<RadioInputProps> = ({ input, id, isDisabled }) => {
  return (
    <InputWrapper>
      <FastField name={id}>
        {({ field, form }: { field: FieldAttributes<any>, form: any }) => {
          return (
            <RadioGroup
              {...field}
              onChange={value => form.setFieldValue(field.name, value)}
              isDisabled={isDisabled}
            >
              <Stack
                direction={input.meta.options.length <= 2 ? 'row' : 'column'}
              >
                {input.meta.options.map((option, i) => (
                  <Radio key={i} value={option.value}>
                    {option.label}
                  </Radio>
                ))}
              </Stack>
            </RadioGroup>
          )
        }}
      </FastField>
    </InputWrapper>
  )
}

export const RadioInput = React.memo((RadioInputComponent), (prevProps, nextProps) => prevProps.id === nextProps.id && _.isEqual(prevProps.input, nextProps.input) )